module.exports = __webpack_public_path__ + "static/media/Silestone-Flash-Promo-Digital-Flyer-USA.902f1de5.pdf";